import { render, staticRenderFns } from "./stores.vue?vue&type=template&id=dbda40ba"
import script from "./stores.vue?vue&type=script&lang=js"
export * from "./stores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports